import {useState } from 'react';
import { Typography, Box, Accordion, AccordionSummary } from "@mui/material";
import './BlogFaq.css';
//import BetaWaitlist from '../../Beta-Waitlist/BetaWaitlist';
import { Link } from 'react-router-dom';
const BlogFaq = () => {
  // Expand all panels by default
  const [expanded, setExpanded] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  // Data for each accordion
  const accordionData = [
    {
        title: "Why is identity verification important in car rentals and how does it relate to KYC compliance?",
        content: "Identity verification is crucial in car rentals to prevent fraud, protect both customers and operators, and build trust within the industry. It is an essential aspect of KYC compliance, ensuring that businesses adhere to regulatory standards.",
    },
    {
        title: "How does verifying customer IDs reduce fraud and prevent identity theft in car rentals?",
        content: "Verifying customer IDs helps to confirm that the person renting the car is who they claim to be, reducing the risk of fraudulent activities such as using stolen identities, identity theft, or fake IDs.",
    },
    {
      title: "What are some risks of not implementing identity verification and KYC processes in car rentals?",
      content: "Without proper identity verification and KYC measures in place, car rental businesses may be vulnerable to fraud, financial losses, and damage to their reputation, particularly in markets such as the USA and Ontario.",
    },
    {
      title: "How can identity verification and the use of Motor Vehicle Records prevent bad actors from renting cars?",
      content: "By verifying customer IDs and utilizing Motor Vehicle Records, car rental companies can screen for individuals with a history of criminal activity or fraudulent behavior, preventing them from renting a car.",
    },
    {
      title: "What tools, such as RFID and Vehicle Information Number (VIN) systems, can streamline the identity verification process in car rentals?",
      content: "There are various tools available, such as RFID technology, ID scanning software, and Vehicle Information Number (VIN) systems, that can streamline the process and make it more efficient for car rental businesses. Companies like Togggle and Klippa provide such services, and organizations like TransUnion and AAMVA.org offer valuable resources.",
    },
    {
      title: "How does identity verification, supported by entities like PALIDIN and CBS Chicago, enhance customer safety and confidence in car rentals?",
      content: "By verifying customer IDs, car rental companies can ensure that the person renting the car is a legitimate and responsible driver, increasing safety for both the customer and the community. Partners like PALIDIN and insights from CBS Chicago help in understanding these dynamics. This also builds trust and confidence in the rental process.",
    },
  ];

 ;


  const handleExpandClick = () => {
    if (isExpanded) {
      // Collapse all and show only the first two
      setExpanded([]);
    } else {
      // Expand all
     // setExpanded(accordionData.map((_, index) => `panel${index}`));
    }
    setIsExpanded(!isExpanded);
  };
  
  

 

  // Toggle accordion panels without collapsing others
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded((prevExpanded) =>
      isExpanded ? [...prevExpanded, panel] : prevExpanded.filter(p => p !== panel)
    );
  };

  return (
    <section className='blogFaqMain'>
        <div className="row justify-content-center">      
          <div className="col-lg-12 col-md-12 col-sm-12">
          
            <div className="blogFaqRight">
                <div className="blogFaqIcon">
                      <div className="row align-items-center">
                          <div className="col-md-4 col-4 faqIcon">
                            <img src="/img/faq.svg" alt="FAQ" className="img-fluid" />
                          </div>
                          <div className="col-md-8 col-8">
                            <p className="d-flex align-items-center justify-content-end m-0"> 
                              <Link onClick={handleExpandClick} className='expandimg expandBtn'>
                              <img
                              src={isExpanded ? "/img/collapse.svg" : "/img/expand-arrow.svg"}
                              alt="Expand arrow"
                              width="24"
                              />
                              {isExpanded ? 'Collapse' : 'Expand'}
                              </Link>
                            </p>
                          </div>
                      </div>
                </div>



              <div className="headblogFaq">
                <h2>Frequently Asked Questions</h2>
              </div>
              <div className="blogFaqRight_Inn">
              {accordionData.map((accordion, index) => (
                (isExpanded || index < 2) && (
                  <Box key={index} className="boxAccordian">
                    <Accordion className="headingAccordian"
                      expanded={expanded.includes(`panel${index}`)}
                      onChange={handleAccordionChange(`panel${index}`)}
                    >
                     <AccordionSummary
                  expandIcon={
                    expanded.includes(`panel${index}`) ? (
                      <Typography variant="h6">−</Typography>
                    ) : (
                      <Typography variant="h6">+</Typography>
                    )
                  }
                  aria-controls={`panel${index}-content`}
                >
                  <Typography>{accordion.title}</Typography>
                </AccordionSummary>

                    </Accordion>
                    {expanded.includes(`panel${index}`) && (
                      <Box className="summaryAccordian">
                        <Typography>{accordion.content}</Typography>
                      </Box>
                    )}
                  </Box>
                )
              ))}

              </div>
                 <div className="load-more">
                     <a onClick={handleExpandClick}>  {isExpanded ? 'View Less' : 'View More'}  <img className='img-fluid'   src={isExpanded ? "img/load-more-less.png" : "/img/faq-elements.png"}  alt="View More"/></a>
                </div>  
              

            </div>
          </div>
        </div>
    </section>
  );
};

export default BlogFaq;
